import { SET_ASSIGNED_ARTWORK_ID } from '@app/actions/_types';

const initialUploadState = {
  assignedArtworkId: null,
};

export default (state = initialUploadState, { type, payload } = {}) => {
  if (type === SET_ASSIGNED_ARTWORK_ID) {
    return { ...state, assignedArtworkId: payload };
  }
  return state;
};
